export default "__VITE_ASSET__fh6NnGjz__"